<template>
    <div class="pageinate">
        <paginate 
            v-model="page"
            :page-count="Math.ceil(length/paginate.size)"
            :prev-text="paginate.prevText"
            :next-text="paginate.nextText"
            :click-handler="clickCallback"
        >
        </paginate>
    </div>
  
</template>

<script>
import Paginate from "vuejs-paginate-next";

export default {
    components: { Paginate },
    props: ["length", "size", "num"],

    data() {
        return {
            page:1,
            paginate: {
                size:this.size,
                num: this.num,
                prevText: '<',
                nextText: '>'
            },
        };
    },

    methods: {
        clickCallback: function (pageNum) {
            this.paginate.num = pageNum;
            this.$router.push({ query: { page: this.paginate.num } });
            this.$emit('update', pageNum);
        }
    },

    watch: {
        $route() {
            if(this.$route.query.page) {
                this.paginate.num = this.$route.query.page;
                this.page = parseInt(this.$route.query.page);
                this.$emit('update', this.paginate.num);
            }
            else {
                this.paginate.num = 1;
                this.page = 1;
                this.$emit('update',1);
            } 
        }
    },

    mounted() {
        if(this.$route.query.page) {
            this.paginate.num = this.$route.query.page;
            this.page = parseInt(this.$route.query.page);
            this.$emit('update', this.paginate.num);
            
        }
    }

}
</script>

<style src="@/assets/css/paginate.css"></style>